import { useState, useCallback } from 'react';

export function useRefresh(refetchFn: () => Promise<unknown> | void) {
  const [isRefreshing, setIsRefreshing]   = useState(false);
  const [lastRefreshed, setLastRefreshed] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    setIsRefreshing(true);
    try {
      await refetchFn();
      setLastRefreshed(new Date());
    } finally {
      setIsRefreshing(false);
    }
  }, [refetchFn]);

  return { isRefreshing, lastRefreshed, refresh };
}
